import { useContext } from "react";

import {
  CoverageSummaryContext,
  type CoverageSummary,
  type UseCoverageSummaryReturn,
} from "../contexts/CoverageSummaryContext";

export type { CoverageSummary };

export function useCoverageSummary(): UseCoverageSummaryReturn {
  const ctx = useContext(CoverageSummaryContext);
  if (!ctx) {
    throw new Error(
      "useCoverageSummary must be used within a CoverageSummaryProvider",
    );
  }

  return ctx;
}
